import { Button, Icon, Spinner } from "@chakra-ui/react";
import { FcGoogle } from "react-icons/fc";

const GoogleAuthButton = ({ onClick, isLoading }) => {
  return (
    <Button
      onClick={onClick}
      isDisabled={isLoading}
      variant="outline"
      size="md"
      w="100%"
      fontWeight="medium"
      fontSize="sm"
      leftIcon={
        isLoading ? <Spinner size="sm" /> : <Icon as={FcGoogle} boxSize={5} />
      }
      borderColor="gray.300"
      _hover={{ bg: "gray.50" }}
      _active={{ bg: "gray.100" }}
    >
      {isLoading ? "Signing in..." : "Continue with Google"}
    </Button>
  );
};

export default GoogleAuthButton;
